import type { FunctionComponent } from 'react';
import type { Components } from 'react-markdown';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { markdownComponents } from './markdown-components';

type ReportMarkdownProps = {
  children: string;
  components?: Components;
};

export const ReportMarkdown: FunctionComponent<ReportMarkdownProps> = ({
  children,
  components,
}) => (
  <ReactMarkdown
    remarkPlugins={[remarkGfm]}
    components={components ? { ...markdownComponents, ...components } : markdownComponents}
  >
    {children}
  </ReactMarkdown>
);
